<ng-template #clipboardButton>
  <app-clipboard-icon height="12px" width="12px" color="#f8f8f2" />
</ng-template>
<markdown clipboard [clipboardButtonTemplate]="clipboardButton" katex [katexOptions]="katexOptions" mermaid
  class="custom-markdown-wrapper message" [ngClass]="customClass" (ready)="onMarkdownReady()" [data]="processedData">
</markdown>
